import * as Sentry from '@sentry/react';
import { ConfigProvider } from 'antd';
import { isLocalhost, sentryRelease } from 'api/common/config';
import { ProposalContextProvider } from 'providers/proposal-provider';
import { UTMContextProvider } from 'providers/utm-provider';
import React from 'react';
import ReactDOM from 'react-dom/client';
import {
  BrowserRouter,
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';
import reportWebVitals from 'reportWebVitals';

import { AuthContextProvider } from 'utils/authProvider';

import { ChatProvider } from '../src/providers/chat-provider';
import App from './app';
import './index.scss';
import { appTheme } from './style-config';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

Sentry.init({
  release: sentryRelease,
  environment: process.env.REACT_APP_SENTRY_ENV,
  dsn: process.env.REACT_APP_SENTRY_DSN_KEY,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
  ],
  dist: './build',
  tracesSampleRate: 1.0,
  tracePropagationTargets: [
    'localhost',
    'https://dev.beebolt.com',
    'https://st.beebolt.com',
    'https://go.beebolt.com',
  ],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  enabled: !isLocalhost,
});

root.render(
  <React.StrictMode>
    <AuthContextProvider>
      <ConfigProvider theme={appTheme}>
        <ChatProvider>
          <BrowserRouter>
            <UTMContextProvider>
              <ProposalContextProvider>
                <App />
              </ProposalContextProvider>
            </UTMContextProvider>
          </BrowserRouter>
        </ChatProvider>
      </ConfigProvider>
    </AuthContextProvider>
  </React.StrictMode>
);

reportWebVitals();
